import invariant from 'tiny-invariant';
import { assign, createMachine, Sender } from 'xstate';
import {
  Context,
  Message,
  ValidationComplete,
  ValidationFailed,
} from './types';

export let feedbackMachine = createMachine<Context, Message>(
  {
    id: 'feedback',
    context: {
      rating: undefined,
      comment: '',
      rating_error: null,
      comment_error: null,
      category: 1,
      eno: undefined,
      serviceId: '',
      xCallerId: '',
    },
    on: {
      update_props: { internal: true, actions: ['set_new_props'] },
    },
    type: 'parallel',
    states: {
      form: {
        initial: 'initial',
        states: {
          initial: {
            on: {
              rating_change: {
                internal: true,
                actions: ['set_rating', 'reset_rating_error'],
              },
              comment_change: {
                internal: true,
                actions: ['set_comment', 'reset_comment_error'],
              },
              submit: { target: 'validating' },
            },
          },
          validating: {
            tags: ['loading_indication'],
            invoke: { src: 'validation', id: 'validation' },
            on: {
              validation_failed: {
                target: 'initial',
                actions: ['set_errors'],
              },
              validation_complete: 'sending',
            },
          },
          sending: {
            tags: ['loading_indication'],
            invoke: { src: 'request', id: 'request' },
            on: {
              request_complete: 'sent',
              request_error: 'request_error',
            },
          },
          request_error: {
            on: {
              modal_close: 'initial',
            },
          },
          sent: {},
        },
      },
      errors: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              validation_failed: 'shown',
            },
          },
          shown: {
            on: {
              submit: { target: 'hidden', actions: ['reset_errors'] },
            },
          },
        },
      },
    },
  },
  {
    actions: {
      set_rating: assign({
        rating: (ctx, message) => {
          invariant(message.type === 'rating_change');
          return message.payload;
        },
      }),
      set_comment: assign({
        comment: (ctx, message) => {
          invariant(message.type === 'comment_change');
          return message.payload;
        },
      }),
      reset_rating_error: assign<Context, Message>({
        rating_error: () => null,
      }),
      reset_comment_error: assign<Context, Message>({
        comment_error: () => null,
      }),
      reset_errors: assign<Context, Message>({
        comment_error: () => null,
        rating_error: () => null,
      }),
      set_errors: assign((ctx, message) => {
        invariant(message.type === 'validation_failed');
        return message.payload;
      }),
      set_new_props: assign((ctx, message) => {
        invariant(message.type === 'update_props');
        return message.payload;
      }),
    },
    services: {
      validation(ctx: Context) {
        return (send: Sender<ValidationFailed | ValidationComplete>) => {
          let rating_error = null;
          let comment_error = null;
          if (!ctx.rating) rating_error = 'RATING_NOT_SELECTED' as const;
          if (ctx.comment.length > 400)
            comment_error = 'COMMENT_TOO_LONG' as const;
          if (rating_error || comment_error) {
            // Нужна задержка, иначе реакт не успевает спрятать ошибки
            setTimeout(send, 100, {
              type: 'validation_failed',
              payload: { rating_error, comment_error },
            });
          } else {
            send({ type: 'validation_complete' });
          }
        };
      },
    },
  }
);
